<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <button type="button" class="in_back_btn" @click="backList">
                    <img src="@/assets/user/line_back_ico_l.png" alt="" />
                    <span>BACK</span>
                </button>
                <p class="page_title">산소포화도 상세 데이터</p>
                <div class="graph_box">
                    <Chart :titlePadding="state.titlePadding" :data="state.chartList"
                        :legendPosition="state.legendPosition" :width="state.chartWidth" :height="state.chartHeight"
                        :title="state.title" :subTitle="state.subTitle">
                    </Chart>
                </div>
                <div class="graph_date_box">
                    <button type="button"><img src="@/assets/user/c_arrow_w_l.png" @click="prevDate" /></button>
                    <span>{{ dateFormat(health.date) }}</span>
                    <button type="button"><img src="@/assets/user/c_arrow_w_r.png" @click="nextDate" /></button>
                </div>
                <div class="data_detail_wrap">
                    <div>
                        <div class="data_detail_tit">산소포화도</div>
                        <table class="detail_s_table" id="oxygen_table">
                            <colgroup>
                                <col width="50%" />
                                <col width="50%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td rowspan="2" class="center">
                                        <div class="oxygen_ave">
                                            <p class="unit_top_txt">%SpO2</p>
                                            <div class="detail_s_flex">
                                                <div class="oxygen_ico_full_img">
                                                    <img src="@/assets/user/oxygen_full.png" alt="" />
                                                </div>
                                                <div>
                                                    <p class="unit_txt blue">
                                                        <b>{{ health.avg }}</b>%
                                                    </p>
                                                    <p class="ico_tit">평균 산소포화도</p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="detail_s_flex">
                                            <div class="oxygen_ico_img">
                                                <img src="@/assets/user/oxygen_up.png" alt="" />
                                            </div>
                                            <div>
                                                <p class="unit_txt">
                                                    <b>{{ health.max }}</b>%
                                                </p>
                                                <p class="ico_tit">최고 산소포화도</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="detail_s_flex">
                                            <div class="oxygen_ico_img">
                                                <img src="@/assets/user/oxygen_down.png" alt="" />
                                            </div>
                                            <div>
                                                <p class="unit_txt">
                                                    <b>{{ health.min }}</b>%
                                                </p>
                                                <p class="ico_tit">최저 산소포화도</p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import {
    Chart,
    HeaderLayout,
    GnbLayout,
    ModalComponent,
    onMounted,
    reactive,
    useRoute,
    apiService,
    globalStore,
    router,
    dateFormat,
} from "@/BaseComponent";

export default {
    props: {},
    components: {
        Chart,
        ModalComponent,
        HeaderLayout,
        GnbLayout,
    },
    setup() {
        const route = useRoute();
        const global = globalStore();
        const state = reactive({
            data: "" as any,
            resultData: [] as any,
            dateList: [] as string[],
            cntHigh: 0 as number,
            cntLow: 0 as number,
            cntMiddle: 0 as number,
            cntTotal: 0 as number,
            chartType: "" as string,
            chartList: { data: [[]], legend: [], category: [] } as any,
            title: "",
            subTitle: "",
            defaultType: "" as string, // line, bar, pie, donut, candle 차트의 초기 값입니다.
            titlePadding: [] as Array<number>, //[up,right,down,left]
            legendPosition: "none" as string, // 'left' bottom
            chartWidth: "100%" as string,
            chartHeight: "250px" as string,
            isModalOpen: false as boolean,
            actionCode: 0 as number,
        });
        const health = reactive({
            min: 0 as number,
            avg: 0 as number,
            max: 0 as number,
            date: "" as string,
        });

        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
        });

        onMounted(() => {
            state.data = route.query.data;
            state.chartType = state.data[1];
            global.setChart(state.chartType);
            getHealthData(state.data[0]);
        });

        const getHealthData = async (key: string) => {
            let paramObj = {
                startDate: "2024-01-01",
                endDate: dateFormat(new Date()),
            };
            let result = await apiService.member.getHealthData(paramObj, key);

            if (result.returnCode === 0) {
                state.chartList = {
                    data: result.data.chartList.map((r: any) => [r.min, r.avg, r.max]),
                    legend: result.data.chartList.map((r: any) => dateFormat(r.groupData)),
                    category: result.data.chartList.map((r: any) => dateFormat(r.groupData)),
                };
                health.min = result.data.chartList[result.data.chartList.length - 1].min;
                health.avg = result.data.chartList[result.data.chartList.length - 1].avg;
                health.max = result.data.chartList[result.data.chartList.length - 1].max;
                state.resultData = result.data.chartList;
                state.dateList = result.dateList;
                health.date = result.dateList[result.dateList.length - 1];
            } else {
                modal.content = result.description;
                modal.confirm = "확인";
                state.isModalOpen = true;
                state.actionCode = 1;
            }
        };
        const backList = () => {
            router.back();
        };

        const prevDate = () => {
            const currentIndex = state.dateList.indexOf(health.date);
            if (currentIndex - 1 < 0) {
                modal.content = "이전 데이터가 없습니다.";
                modal.cancel = "확인";
                state.isModalOpen = true;
            } else {
                health.date = state.dateList[currentIndex - 1];
                const selectData = state.resultData.filter((item: any) => item.groupData === Number(health.date));
                health.min = selectData[0].min;
                health.max = selectData[0].max;
                health.avg = selectData[0].avg;
            }
        };

        const nextDate = () => {
            const currentIndex = state.dateList.indexOf(health.date);
            if (currentIndex + 1 >= state.dateList.length) {
                modal.content = "다음 데이터가 없습니다.";
                modal.cancel = "확인";
                state.isModalOpen = true;
            } else {
                health.date = state.dateList[currentIndex + 1];
                const selectData = state.resultData.filter((item: any) => item.groupData === Number(health.date));
                health.min = selectData[0].min;
                health.max = selectData[0].max;
                health.avg = selectData[0].avg;
            }
        };
        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            switch (state.actionCode) {
                case 1:
                    state.actionCode = 0;
                    backList();
                    break;

                default:
                    break;
            }
            if (result) {
                backList();
            }
        };
        return {
            state,
            modal,
            health,
            backList,
            nextDate,
            prevDate,
            modalClose,
            dateFormat,
        };
    },
};
</script>
